import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory, createMemoryHistory } from 'history';
import { Provider } from 'react-redux';

// Polyfill set
import 'core-js/es6/set';
import 'normalize.css';
import Routes from './pages/routes';
import store from './store';
import './pages/App.css';

const history = typeof window !== 'undefined' ? createBrowserHistory() : createMemoryHistory();

ReactDOM.render(<Provider store={store}><Routes history={history} /></Provider>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js